import Components from '../../Components';

const { containerTypes } = Components.Routes;

const RouteConfig = {
  path: '/forgotpassword',
  exact: true,
  name: 'navigation.menu.forgotpassword',
  private: false,
  type: containerTypes.PAGE,
};

export default RouteConfig;
